import { render, staticRenderFns } from "./qj.vue?vue&type=template&id=2a0ed81c&scoped=true"
import script from "./qj.vue?vue&type=script&lang=js"
export * from "./qj.vue?vue&type=script&lang=js"
import style0 from "./qj.vue?vue&type=style&index=0&id=2a0ed81c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0ed81c",
  null
  
)

export default component.exports